export const Pencil = () => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.33333 2.21891L10 4.88558M1 11.219H3.66667L10.6667 4.21895C11.0203 3.86533 11.219 3.38572 11.219 2.88562C11.219 2.38552 11.0203 1.90591 10.6667 1.55228C10.313 1.19866 9.83343 1 9.33333 1C8.83324 1 8.35362 1.19866 8 1.55228L1 8.55228V11.219Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
)
